import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { createAppStore, getPersistor } from '@ideoz/core';
import App from './App';
import './index.scss';

// Create Redux store
const store = createAppStore();
const persistor = getPersistor(store);

const rootElement = document.getElementById('root');

if (rootElement) {
  // Store the root instance on the element to persist across HMR updates
  if (!(rootElement as any)._reactRoot) {
    (rootElement as any)._reactRoot = ReactDOM.createRoot(rootElement);
  }
  (rootElement as any)._reactRoot.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
}
